export const raceNames = new Map();

raceNames.set("Practice 1", "circuit_modal_practice_1");
raceNames.set("Practice 2", "circuit_modal_practice_2");
raceNames.set("Practice 3", "circuit_modal_practice_3");
raceNames.set("Qualifying", "circuit_modal_qualifying");
raceNames.set("Race", "circuit_modal_race");
